import { React, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../blockpay.css";
import Img from "../../images/login.png";
import Logo from "../../images/logo 01.png";
import AppStore from "../../images/App Store.svg";
import Gplay from "../../images/Google Play.svg";
import Grid from "@mui/material/Unstable_Grid2";
import axios from "axios";
import { setAuthToken } from "../../utils/setAuthToken";
import Pin from "../SignUp/pin";
import { SHA256 } from "crypto-js";
import {
  Card,
  CardContent,
  TextField,
  Button,
  Box,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";
import GoogleImg from "../../images/google.png";
import AppleImg from "../../images/apple.png";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function Login2Pin() {
  const [email, setEmail] = useState("");
  const [pin, setPin] = useState("");
  const navigate = useNavigate();
  const calculateHash = (inputValue) => {
    const hashedValue = SHA256(inputValue).toString();
    return hashedValue;
  };

  const handleMainLogoClick = () => {
    navigate("/");
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(email, pin, calculateHash(pin));
    axios
      .post("https://api.blockpay.co.za/merchant/login", {
        email: email,
        password: calculateHash(pin),
        issmartpin: true,
      })
      .then((res) => {
        toast.success(res.data.message);
        console.log(res.data);
        // window.location.reload();
        localStorage.setItem("jwtToken", res.data.token);
        localStorage.setItem("name", res.data.name);
        localStorage.setItem("refreshToken", res.data.refreshToken);
        // history.push('/dashboard');
        navigate("/dashboard", { replace: true });
        setAuthToken(res.data.token);
      })
      .catch((err) => {
        toast.error(err.response.data.message);
        console.log(err);
        if (err.response.data.message=="Unauthorized!"){
          localStorage.clear();
          navigate("/signinpin", {replace:true});
        }
      });
  };

  return (
    <>
      <ToastContainer />
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          "@media (max-width:900px)": {
            display: "flex",
            justifyContent: "center!important",
          },
        }}
      >
        <img src={Logo} className="loginLogoImg" onClick={handleMainLogoClick} style={{ cursor: 'pointer' }} />
      </Box>
      <Grid container className="loginGrid">
        <Grid
          xs={12}
          md={5}
          lg={6}
          sx={{
            display: { xs: "none", md: "grid", lg: "flex" },
            justifyContent: "flex-end",
          }}
        >
          <img src={Img} className="loginImg" />
        </Grid>
        <Grid xs={12} md={7} lg={6} className="loginGridCol2">
          <Box className="loginCard">
            <CardContent>
              <Box
                sx={{
                  fontSize: "h4.fontSize",
                  fontWeight: "bold",
                  marginBottom: 2,
                }}
              >
                Log in
              </Box>
              <form onSubmit={handleSubmit}>
                <TextField
                  id="email"
                  className="logintextField"
                  label="Email address"
                  InputLabelProps={{ shrink: true }}
                  variant="outlined"
                  type="email"
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <Box
                  sx={{ textAlign: "left", mb: "0.5rem" }}
                  className="otpInput"
                >
                  <p className="pinPlaceholder">Smart Pin *</p>
                  <Pin otp={pin} setOtp={setPin} />
                  {/* <Typography className="loginFPass">Forget Pin?</Typography> */}
                </Box>

                <Button
                  className="loginButton"
                  variant="contained"
                  color="primary"
                  type="submit"
                  size="large"
                  sx={{ textTransform: "none", borderRadius: "10px" }}
                >
                  Log in
                </Button>
              </form>
            </CardContent>
          </Box>
          <Box className="loginCard2">
            <CardContent sx={{ fontSize: 19, padding: "10px!important" }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "#666666",
                }}
              >
                <Box
                  component="img"
                  src={GoogleImg}
                  sx={{ height: "30px", marginRight: "1rem" }}
                />{" "}
                Continue with Google
              </Box>
            </CardContent>
          </Box>
          <Box className="loginCard2">
            <CardContent sx={{ fontSize: 19, padding: "10px!important" }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "#666666",
                }}
              >
                <Box
                  component="img"
                  src={AppleImg}
                  sx={{ height: "30px", marginRight: "1rem" }}
                />{" "}
                Continue with Apple
              </Box>
            </CardContent>
          </Box>
          <Box sx={{ fontSize: "19px", marginTop: "3rem" }}>
            Don't have an account?{" "}
            <span>
              <Link to="/signup" className="underline">
                Sign Up
              </Link>
            </span>
          </Box>
          <Box
            sx={{
              marginTop: "2rem",
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-end",
              background: "linear-gradient(90deg, #05B2FF 0%, #9340E2 70%)",
              backgroundClip: "text",
              WebkitBackgroundClip: "text, border",
              WebkitTextFillColor: "transparent",
              textDecoration: "underline blueviolet 1px!important",
              textUnderlinePosition: "under",
            }}
          >
            <Box
              component={Link}
              to="/signinpass"
              sx={{ display: "flex", mb: "10px" }}
            >
              <Typography sx={{ fontSize: "19px" }}>
                Log in with &nbsp;
              </Typography>
              <Typography sx={{ fontWeight: "500", fontSize: "19px" }}>
                Password
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </>
  );
}
